//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfPrice from "../../atoms/SfPrice/SfPrice.vue";
import SfIcon from "../../atoms/SfIcon/SfIcon.vue";
import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfBadge from "../../atoms/SfBadge/SfBadge.vue";
import SfAddToCart from "../../molecules/SfAddToCart/SfAddToCart.vue";
import { getCMSLabels } from '~/helpers/globalLabels';
import { handleImageError } from "~/common";

export default {
  name: "SfProductCardHorizontal",
  components: {
    SfPrice,
    SfIcon,
    MoominLink,
    SfButton,
    SfBadge,
    SfAddToCart,
  },
  props: {
    showRemoveItem: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    smallPicture: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: "",
    },
    removeLabel: {
      type: String,
      default: "Remove",
    },
    exclusiveLabel: {
      type: String,
    },
    exclusivePriceLabel: {
      type: Boolean,
    },
    customBadgeColor: {
      type: String,
      default: "var(--c-secondary-turquoise)",
    },
    badgeColor: {
      type: String,
      default: "",
    },
    image: {
      type: [Array, Object, String],
      default: "",
    },
    imageWidth: {
      type: [Number, String],
      default: null,
    },
    imageHeight: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    link: {
      type: [String, Object],
      default: "",
    },
    hideAddToCart: {
      type: Boolean,
      default: false,
    },
    /**
     * Link element tag
     * @deprecated will be removed. Use slot to replace content
     */
    linkTag: {
      type: String,
      default: undefined,
    },
    scoreRating: {
      type: [Number, Boolean],
      default: false,
    },
    reviewsCount: {
      type: [Number, Boolean],
      default: false,
    },
    maxRating: {
      type: [Number, String],
      default: 5,
    },
    totalPriceValue: {
      type: [Number, String],
      default: null,
    },
    regularPrice: {
      type: [Number, String],
      default: null,
    },
    specialPrice: {
      type: [Number, String],
      default: null,
    },
    lowestPrice: {
      type: [Number, String],
      default: null,
    },
    totalPrice: {
      type: [Number, String],
      default: null,
    },
    wishlistIcon: {
      type: [String, Array, Boolean],
      default: "heart",
    },
    isInWishlistIcon: {
      type: [String, Array],
      default: "heart_fill",
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },
    qty: {
      type: [Number, String],
      default: 1,
    },
    imageTag: {
      type: String,
      default: "",
    },
    nuxtImgConfig: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      default: () => ({})
    },
    showPerUnitTotalPrice: {
      type: Boolean,
      default: false,
    },
    onlyAvailableTo: String,

  },
  data() {
    return {
      quantity: this.qty,
    };
  },
  computed: {
    currentWishlistIcon() {
      return this.isInWishlist ? this.isInWishlistIcon : this.wishlistIcon;
    },
    ariaLabel() {
      return this.isInWishlist ? "Remove from wishlist" : "Add to wishlist";
    },
    itemQuantity: {
      get() {
        return typeof this.quantity === "string"
          ? Number(this.quantity)
          : this.quantity;
      },
      set(newValue) {
        this.quantity = newValue;
      },
    },
    badgeLabelDisplay(){
      return this.onlyAvailableTo ?'' :'display-none'
    }

  },
  methods: {
    toggleIsInWishlist() {
      this.$emit("click:wishlist", !this.isInWishlist);
    },
    getLowestPriceLabel() {
      return getCMSLabels('lowestprice');
    },


  },
  setup(props, { emit }) {

    const exclusiveLabelText =  getCMSLabels('my-moomin-exclusive');
    const exclusivePriceLabelText = getCMSLabels('my-moomin-price')

    const removeItem = () => {
      const data = {
        product: props.product,
        entryNumber: props.product.itemId,
      }

      emit('removeItem', data)
    };
    const qtyInputUpdate = ($event) => {
      const data = {
        product: props.product,
        diff: Number($event) - Number(props.qty),
        qty: Number($event),
        entryNumber: props.product.itemId
      }
      emit('qtyInputUpdate', data)
    }
    return {
      removeItem,
      qtyInputUpdate,
      handleImageError,
      exclusiveLabelText,
      exclusivePriceLabelText
    }
  }
};
